import { Interpolation } from "@emotion/core";
import { grid } from "../../design-tokens/grid";
import { Colors } from "../../design-tokens/colors";
import { DarkTheme, Device } from "../../design-tokens/media-queries";

const root: Interpolation = {
  position: "relative",
  marginBottom: grid(2),
};

const container: Interpolation = {
  height: "200px",
  fontSize: "12px",
  marginBottom: grid(3),

  text: {
    fontSize: "12px",
  },

  [DarkTheme]: {
    text: {
      fill: Colors.DarkModeWhite,
      opacity: 0.8,
    },
  },

  [Device.DesktopTablet]: {
    height: "300px",
    fontSize: "14px",
    marginBottom: grid(4),

    text: {
      fontSize: "14px",
    },
  },
};

const watermarkCover: Interpolation = {
  position: "absolute",
  width: 70,
  height: 25,
  backgroundColor: Colors.White,
  bottom: 0,
  left: -20,

  [DarkTheme]: {
    backgroundColor: Colors.DarkModeBackground,
  },
};

const styles = {
  root,
  container,
  watermarkCover,
};

export default styles;
